import { InjectionToken } from '@angular/core';

export const IS_MICROFRONTEND = new InjectionToken<boolean>('IS_MICROFRONTEND');

export const MFE_BASE_URL_TOKEN = new InjectionToken<string>('MFE_BASE_URL');

export const SHADOW_ROOT_TOKEN = new InjectionToken<ShadowRoot>('SHADOW_ROOT');

export const OVERLAY_ROOT_TOKEN = new InjectionToken<HTMLElement>('OVERLAY_ROOT');
